module.exports = __webpack_public_path__ + "static/img/auto-bell-web-img@t.245b085.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/glovis-aa/auto-bell-web-img@t.png
// module id = fD9+
// module chunks = 0